/**
 * Shared POST /devices/:id/commands handler for device firmware update flows (Edgecaster / Max).
 */
export function runDeviceFirmwareCommand(vm, command) {
  var device = vm.device
  var helpers = vm.$helpers

  device.command_status = 'issued'
  device.command_message = 'Update Requested'

  return vm.axios.post('/devices/' + device.device_guid + '/commands', { command: command })
    .then(function (response) {
      device.last_api_request_id = response.data.api_request_id
      device.command_status = 'accepted'
      device.command_message = 'Update Command Accepted'
      device.commandGUID = response.data.command_guid
      device.command = 'update_device'

      if (device.commandGUID) {
        device.commandResponseTimer = setTimeout(function () {
          device.commandResponseCheckAttempt++
          device.checkDeviceCommand(device.commandGUID)
        }, device.commandResponseCheckInterval)
      }
      return response
    })
    .catch(function (error) {
      device.command_status = 'error'
      device.command_message = helpers.parseError(error)
      return Promise.reject(error)
    })
}
